module.exports = __webpack_public_path__ + "img/foul_atras.cdf09c69.gif";